import { dispatchMultipleActions } from '../../dispatchHelper.js';
import { accountService } from '../../../services/account.service.js';
import { stripePaymentService } from '../../../services/stripe-payment.service.js';

import { setInviteUsers, setMembersAccount, setSelectedAccount } from '../reducers/account.reducer.js';
import { store } from '../../store.js';
import { setPlan } from '../../plans/reducers/plan.reducer.js';
import { setLoading } from '../../user/reducers/auth.reducer.js';
import { uploadService } from '../../../services/upload.service.js';

const dispatch = store.dispatch;

export async function editAccount(id, obj) {
    try {
        dispatch(setLoading(true))

        await accountService.update(id, obj);

        if (id) await fetchAccount(id);
    } catch (err) {
        console.log('Had issues loading', err);
        dispatch(setLoading(false))
        throw err;
    } finally {
        dispatch(setLoading(false))
    }
}

export async function editAccountFiles(account, accountFiles) {
    try {
        dispatch(setLoading(true));

        // Verifica se avatar é File
        if (accountFiles.avatar instanceof File) {
            const avatarUpload = await uploadService.uploadFiles(accountFiles.avatar, account?._id, 'account');
            const avatarExt = avatarUpload.originalName.split('.').pop();
            accountFiles.avatar = `${avatarUpload.uuid}.${avatarExt}`;
        }

        // Verifica se wallpaper é File
        if (accountFiles.wallpaper instanceof File) {
            const wallpaperUpload = await uploadService.uploadFiles(accountFiles.wallpaper, account?._id, 'account');
            const wallpaperExt = wallpaperUpload.originalName.split('.').pop();
            accountFiles.wallpaper = `${wallpaperUpload.uuid}.${wallpaperExt}`;
        }

        const newAccount = await accountService.updateFiles(account?._id, accountFiles);

        if (newAccount)
            fetchAccount(newAccount?._id);

    } catch (error) {
        dispatch(setLoading(false));

        throw error;
    } finally {
        dispatch(setLoading(false));
    }
}

export async function removeInviteUser(accountId, email) {
    try {
        const { inviteUsers, updatedAccount } = await accountService.removeInviteUser(accountId, email);

        dispatchMultipleActions(
            setInviteUsers(inviteUsers),
            setMembersAccount(updatedAccount.users)
        );

    } catch (err) {
        console.error(`Erro ao remover usuário convidado ${email}:`, err);
    }
}


export async function addInviteUser(accountId, inviteData) {
    try {
        const { inviteUsers, updatedAccount } = await accountService.inviteUser(accountId, inviteData);
        dispatchMultipleActions(
            setInviteUsers(inviteUsers),
            setMembersAccount(updatedAccount.users)
        );
    } catch (err) {
        console.error('Erro ao adicionar um novo usuário convidado:', err);
        throw err;
    }
}

export async function fetchAccount(id) {
    try {
        const account = await accountService.getById(id);

        const selected = {
            accountId: account
        };

        dispatchMultipleActions(
            setSelectedAccount(selected),
            setInviteUsers(account.inviteUsers || []),
            setMembersAccount(account.users)
        );

        return account;
    } catch (err) {
        console.error("Erro ao buscar a conta:", err);
    }
}

export async function removeMember(accountId, userId) {
    try {
        const response = await accountService.removeMemberUser(accountId, userId);

        if (!response) {
            throw new Error("Lista de membros não foi retornada corretamente da API.");
        }

        dispatchMultipleActions(
            setMembersAccount(response)
        );

    } catch (err) {
        console.error(`Erro ao remover membro ${userId}:`, err);
    }
}
export async function getAccount(accountId) {
    try {
        dispatchMultipleActions(
            setSelectedAccount(accountId)
        );
    } catch (err) {
        console.error(`Erro ao buscar account`, err);
    }
}

export async function getActiveNotices() {
    try {
        const data = await accountService.getActiveNotice();
        return data;
    } catch (error) {
        console.error('Erro ao buscar aviso:', error);
        throw error;
    }
}


export async function getStatsForCompany(id) {
    try {
        const data = await accountService.getCompanyStats(id);
        return data;
    } catch (error) {
        console.error('Erro ao buscar informalções do account:', error);
        throw error;
    }
}

export async function getBetterPlanByAccountStats(accountStats, id, planId) {
    try {
        const data = await accountService.getBetterPlan(accountStats, id, planId);
        return data;
    } catch (error) {
        console.error('Erro ao buscar melhor plano para account:', error);
        throw error;
    }
}

export async function getAllNameFilesOfAccount(id, opts) {
    try {
        const data = await accountService.getCompanyNameFiles(id, opts);
        return data;
    } catch (error) {
        console.error('Erro ao buscar arquivos do account:', error);
        throw error;
    }
}

export async function getLogOfAccount(id, opts) {
    try {
        const data = await accountService.getAccountLogs(id, opts);
        return data;
    } catch (error) {
        console.error('Erro ao buscar arquivos do account:', error);
        throw error;
    }
}

export function getActionDescription(action, length, to = '') {
    // account
    if (action.includes('account-fileAvatar')) return `Alterou o avatar da empresa`;
    if (action.includes('account-fileWallpaper')) return `Alterou o wallpaper da empresa`;
    if (action.includes('account-removedWallpaper')) return `Removeu o wallpaper da empresa`;
    if (action.includes('account-removedAvatar')) return `Removeu o avatar da empresa`;
    if (['account-deleteData'].includes(action)) {
        return `Deletou  ${length > 1 ? 'os itens arquivados' : 'o item arquivado'}`;
    }

    //preRegistration
    if (action.includes('preRegistration-create')) return `Criou o Pré-Cadastro`;
    if (action.includes('preRegistration-delete')) return `Deletou o Pré-Cadastro`;
    if (action.includes('preRegistration-update-title')) return `Atualizou o Pré-Cadastro`;
    if (action.includes('preRegistration-update-multiple')) return `Atualizou o Pré-Cadastro`;
    if (action.includes('preRegistration-update-title')) return `Atualizou o Pré-Cadastro`;
    if (action.includes('preRegistration-field-create')) return `Criou o campo ${to} do Pré-cadastro`;
    if (action.includes('preRegistration-field-delete')) return `Deletou o campo ${to} do Pré-cadastro`;
    if (action.includes('preRegistration-field-update')) return `Atualizou o campo do Pré-Cadastro`;

    //registration
    if (action.includes('registration-create')) return `Criou o Registro`;
    if (action.includes('registration-delete')) return `Deletou o Registro`;
    if (action.includes('registration-update')) return `Atualizou o Registro do Pré-Cadastro`;


    // desktop
    if (action.includes('desktop-create')) return `Criou o desktop`;
    if (action.includes('desktop-delete')) return `Deletou o desktop`;
    if (['desktop-removedAllowedUsers', 'board-removedAllowedUsers'].includes(action)) {
        return `Removeu a permissão ${length > 1 ? 'dos usuários' : 'do usuário'}`;
    }
    if (['desktop-addAllowedUsers', 'board-addAllowedUsers'].includes(action)) {
        return `Deu permissão ${length > 1 ? 'para os usuários' : 'para o usuário'}`;
    }
    if (action.includes('desktop-descRename')) return `Alterou a descrição do desktop`;
    if (action.includes('desktop-rename')) return `Renomeou o desktop`;
    if (action.includes('desktop-fileAvatar')) return `Alterou o avatar do desktop`;
    if (action.includes('desktop-fileWallpaper')) return `Alterou o wallpaper do desktop`;
    if (action.includes('desktop-avatarColor')) return `Alterou a cor do avatar do desktop`;
    if (action.includes('desktop-moveChildrens')) return `Alterou a ordem das boards/pastas do desktop`;
    if (action.includes('desktop-removedWallpaper')) return `Removeu o wallpaper do desktop`;
    if (action.includes('desktop-removedAvatar')) return `Removeu o avatar do desktop`;

    //board/folder
    if (action.includes('board-createAutomation')) return `Criou uma Automatização na board`;
    if (action.includes('board-editAutomation')) return `Editou uma Automatização na board`;
    if (action.includes('board-deleteAutomation')) return `Deletou uma Automatização na board`;
    if (action.includes('folder-create')) return `Criou a pasta`;
    if (action.includes('board-create')) return `Criou a board`;
    if (action.includes('board-deleteSelected')) return `Deletou os itens da board`;
    if (action.includes('board-restoreSelected')) return `Restaurou os itens da board`;
    if (action.includes('board-deleteAll')) return `Deletou a board`;
    if (action.includes('board-delete')) return `Arquivou a board`;
    if (action.includes('folder-delete')) return `Deletou a pasta`;
    if (action.includes('board-rename')) return `Renomeou a board`;
    if (action.includes('board-descRename')) return `Alterou a descrição da board`;
    if (action.includes('board-restoreAll')) return `Restaurou por completo a board`;
    if (action.includes('board-restore')) return `Restaurou a board`;
    if (action.includes('folder-rename')) return `Renomeou a pasta`;
    if (action.includes('board-favorite')) return `${to === 'added' ? 'Adicionou aos' : 'Removeu dos'} favoritos a board`;


    //group 
    if (action.includes('group-create')) return `Criou o grupo`;
    if (action.includes('group-rename')) return `Renomeou o grupo`;
    if (action.includes('group-changeIcon')) return `Alterou o icone do grupo`;
    if (action.includes('group-changeColor')) return `Alterou a cor do grupo`;
    if (action.includes('group-delete')) return `Arquivou o grupo`;
    if (action.includes('group-duplicate')) return `Duplicou o grupo`;


    // form
    if (action.includes('form-rename')) return `Renomeou o formulário da board`;
    if (action.includes('form-descRename')) return `Alterou a descrição formulário da board`;
    if (action.includes('form-pageName')) return `Alterou a URL do formulário da board`;
    if (action.includes('form-isPrivate')) return `Alterou o formulário para ${to === true ? 'privado' : 'público'} da board`;
    if (action.includes('form-password')) return `Alterou a senha do formulário da board`;
    if (action.includes('form-changeGroup')) return `Alterou o grupo responsável no formulário da board`;
    if (action.includes('form-isInactive')) return `${to === true ? 'Inativou' : 'Ativou'} o formulário da board`;
    if (action.includes('form-fieldsChanged')) return `Alterou os campos do formulário da board`;



    // users
    if (action.includes('user-login')) return `Usuário se logou`;
    if (action.includes('user-logout')) return `Usuário se deslogou`;
    if (action.includes('user-fileChange')) return `Alterou sua foto de perfil para`;
    if (action.includes('user-changeName')) return `Alterou seu nome`;
    if (action.includes('user-changeEmail')) return `Alterou seu email`;
    if (action.includes('user-changeBirthday')) return `Alterou sua data de aniversário`;
    if (action.includes('user-changePhone')) return `Alterou seu número de telefone`;

    if (action.includes('invite-createUser')) return `Criou seu usuário através do método convidar`;
    if (action.includes('invite-remove')) return `Removeu o convite para`;
    if (action.includes('invite-resend')) return `Reenviou o convite para`;
    if (action.includes('invite')) return `Enviou um convite para`;

    // graficos e acumuladores
    if (action.includes('chart-create')) return `Criou o gráfico ${to} em`;
    if (action.includes('accumulator-create')) return `Criou o acumulador ${to} em`;
    if (action.includes('chart-delete')) return `Deletou o gráfico ${to} em`;
    if (action.includes('accumulator-delete')) return `Deletou o acumulador ${to} em`;

    return `Alteração`;
}

// export async function openAccountFile(id, opts) {
//     try {
//         const data = await accountService.getCompanyFileUrl(id, opts);
//         return data;
//     } catch (error) {
//         console.error('Erro ao buscar arquivos do account:', error);
//         throw error;
//     }
// }

export async function addLogAccount(accountId, field, byMember) {
    try {
        return await accountService.addLog(accountId, field, byMember);
    } catch (err) {
        console.error('Erro ao adicionar o log ao account:', err);
        throw err;
    }
}

export async function getInfoAccountsByUserId(userId) {
    try {
        dispatchMultipleActions(setLoading(true));
        const data = await accountService.getInfoAccountsByUserId(userId);
        return data;
    } catch (error) {
        dispatchMultipleActions(setLoading(false));
        console.log('erro ao consutlar accounts');
        throw error;
    } finally {
        dispatchMultipleActions(setLoading(false));
    }
}


// funções stripe
export async function getBilling(accountId) {
    try {
        const data = await stripePaymentService.getBillingBId(accountId);
        return data;
    } catch (error) {
        console.error('Erro ao buscar billing:', error);
        throw error;
    }
}
export async function billingEnsure(accountId) {
    try {
        const data = await stripePaymentService.ensureBilling(accountId);
        return data;
    } catch (error) {
        console.error('Erro ao buscar billing:', error);
        throw error;
    }
}


export async function createCustumer(body) {
    try {
        const data = await stripePaymentService.createCust(body);
        return data;
    } catch (error) {
        console.error('Erro ao criar custumer:', error);
        throw error;
    }
}

export async function checkCustumer(customerId) {
    try {
        const result = await stripePaymentService.existCustomer(customerId);
        return result;
    } catch (error) {
        console.error('Erro ao criar custumer:', error);
        throw error;
    }
}

export async function createCheckout(body, plan) {
    try {
        const data = await stripePaymentService.createCheckSession(body, plan);
        return data;
    } catch (error) {
        console.error('Erro ao criar sessão:', error);
        throw error;
    }
}

export async function updatePaymentMethod(body, plan) {
    try {
        const data = await stripePaymentService.updatePayMethod(body, plan);
        await fetchAccount(data?.account._id);

        return data;
    } catch (error) {
        console.error('Erro ao criar sessão:', error);
        throw error;
    }
}

export async function paymentIntent(body, plan) {
    try {
        const data = await stripePaymentService.payment(body, plan);
        await fetchAccount(data?.account._id);
        dispatchMultipleActions(
            setPlan(data?.plan)
        );
        return data;
    } catch (error) {
        console.error('Erro ao realizar pagamento:', error);
        throw error;
    }
}

export async function getDataSession(id) {
    try {
        const data = await stripePaymentService.dataSession(id);
        return data;
    } catch (error) {
        console.error('Erro ao realizar pagamento:', error);
        throw error;
    }
}


export async function getCardCustomer(customerId) {
    try {
        const data = await stripePaymentService.getCardInfo(customerId);
        return data;
    } catch (error) {
        console.error('Erro ao buscar card:', error);
        throw error;
    }
}

export async function validatePlanData(accountId, resource, sizeBytes) {
    try {
        const valid = await accountService.validateDataPlan(accountId, resource, sizeBytes);
        return valid;
    } catch (error) {
        console.error('Erro ao validar dados com o plano:', error);
        throw error;
    }
}


export async function accountPlanChoicedToStart(accountId, planId, userId) {
    try {
        const data = await accountService.choicePlan(accountId, planId, userId);
        await fetchAccount(data?.accountId)
        return data;
    } catch (error) {
        console.error('Erro ao salvar plano escolhido no account:', error);
        throw error;
    }
}


export async function choiceFreePlan(accountId, planId) {
    try {
        const data = await accountService.choiceFreePlan(accountId, planId);
        await fetchAccount(data?.accountId);
        dispatchMultipleActions(
            setPlan(data?.plan)
        );
        return data;
    } catch (error) {
        console.error('Erro ao salvar plano escolhido no account:', error);
        throw error;
    }
}

export async function getMyPreRegistrations(accountId) {
    try {
        const data = await accountService.getPreRegistration(accountId);
        return data;
    } catch (error) {
        console.error('Erro ao buscar pre cadastros:', error);
        throw error;
    }
}

export async function createNewPreRegistration(accountId, userId) {
    try {
        const data = await accountService.createPreRegistration(accountId, userId);
        await fetchAccount(data?.accountId);
        return data;
    } catch (error) {
        console.error('Erro ao criar pre cadastro:', error);
        throw error;
    }
}

export async function updatePreRegistration(accountId, id, userId, payload) {
    try {
        const data = await accountService.updatePreRegistration(accountId, id, userId, payload);
        await fetchAccount(data?.accountId);
        return data;
    } catch (error) {
        console.error('Erro ao atualizar pre cadastro:', error);
        throw error;
    }
}

export async function deletePreRegistration(accountId, userId, id) {
    try {
        const data = await accountService.deletePreRegistration(accountId, userId, id);
        await fetchAccount(data?.accountId);
        return data;
    } catch (error) {
        console.error('Erro ao deletar pre cadastro:', error);
        throw error;
    }
}

export async function updateFields(accountId, preRegistrationId, userId, payload) {
    try {
        const data = await accountService.updateFields(accountId, preRegistrationId, userId, payload);
        await fetchAccount(data?.accountId);
        return data;
    } catch (error) {
        console.error('Erro ao atualizar fields:', error);
        throw error;
    }
}
export async function updateRecordValue(accountId, preRegistrationId, userId, payload) {
    try {
        const data = await accountService.updateRecords(
            accountId,
            preRegistrationId,
            userId,
            payload
        );

        await fetchAccount(data?.accountId);
        return data;
    } catch (error) {
        throw error;
    }
}


export async function createNewRecord(accountId, PreRegistrationId, payload) {
    try {
        const data = await accountService.createRecords(accountId, PreRegistrationId, payload);
        await fetchAccount(data?.accountId);
        return data;
    } catch (error) {
        console.error('Erro ao criar pre cadastro:', error);
        throw error;
    }
}

export async function updatePreRegistrationOrder(accountId, preRegistrations) {
    try {
        console.log('preRegistrations', preRegistrations);
    } catch (error) {
        console.error('Erro ao criar pre cadastro:', error);
        throw error;
    }
}

export async function deleteRecord(accountId, userId, PreRegistrationId, id) {
    try {
        const data = await accountService.deleteRecord(accountId, userId, PreRegistrationId, id);
        await fetchAccount(data?.accountId);
        return data;
    } catch (error) {
        console.error('Erro ao criar pre cadastro:', error);
        throw error;
    }
}